import type { BatchPreviewTableColumn } from "../batch-preview-table";
import type { ObservationLite } from "@/entities/observation";

import { useTranslation } from "react-i18next";

import { useGetObservations } from "@/entities/observations";
import ObservationBreadcrumb from "@/modules/observation/observation-breadcrumb";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";
import { sortTexts } from "@/utilities/string";

import {
  useBatchPreviewTableColumnName,
  useBatchPreviewTableColumnState,
} from "../batch-preview-table";
import { BATCH_PREVIEW_PAGE_SIZE } from "../batch-preview.constant";
import { useBatchPreviewIdsParam } from "../batch-preview.hook";

export const useBatchPreviewObservationTransitionPage = () => {
  const { t } = useTranslation();
  const { idsParam, ids } = useBatchPreviewIdsParam();

  const { observations, isLoading } = useGetObservations({
    enabled: ids.length > 0,
    params: {
      "filter[id]": idsParam,
      "page[size]": BATCH_PREVIEW_PAGE_SIZE,
    },
  });

  const columns: BatchPreviewTableColumn<ObservationLite>[] = [
    useBatchPreviewTableColumnName("observation"),
    {
      key: "asset",
      dataIndex: "asset.name",
      title: t("global:asset"),
      render: (_asset, observation) => (
        <ObservationBreadcrumb
          observation={observation}
          include={["asset"]}
          hideIcon
          ellipsis
          compact
        />
      ),
      ...TABLE_FILTER_TEXT,
      onFilter: (value, observation) =>
        observation.asset.name.includes(value as string),
      sorter: (a, b) => sortTexts(a.asset.name, b.asset.name),
    },
    {
      key: "source_intervention",
      dataIndex: "source_intervention.name",
      title: t("global:intervention"),
      render: (_intervention, observation) => (
        <ObservationBreadcrumb
          observation={observation}
          include={["intervention"]}
          hideIcon
          ellipsis
          compact
        />
      ),
      ...TABLE_FILTER_TEXT,
      onFilter: (value, observation) =>
        observation.source_intervention.name.includes(value as string),
      sorter: (a, b) =>
        sortTexts(a.source_intervention.name, b.source_intervention.name),
    },
    useBatchPreviewTableColumnState("observation", observations),
  ];

  return {
    observations,
    loading: isLoading,
    columns,
  };
};
